import React from 'react';

import cx from 'classnames';

import styles from './Checkbox.scss';

export type CheckboxProps = {
  label?: string | JSX.Element;
  id?: string;
  name?: string;
  value: string;
  checked?: boolean;
  onChange?(
    event: React.FormEvent<HTMLInputElement>,
    newChecked: boolean,
    name: string,
  ): void;
  onBlur?(event: React.FocusEvent): void;
};

export const Checkbox: React.FunctionComponent<CheckboxProps> = ({
  label,
  ...props
}) => {
  const onChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, checked: newChecked } = event.currentTarget;
    if (props.onChange) props.onChange(event, newChecked, name);
  };

  return (
    <div className="jg-display-flex jg-flex-aic jg-space-mbmd">
      <input
        id={props.id || props.name}
        type="checkbox"
        className={cx('jg-form-control', styles.checkbox)}
        {...props}
        /* this onChange overwrite props.onChange */
        onChange={onChange}
      />
      <label htmlFor={props.id || props.name}>{label}</label>
    </div>
  );
};
